import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";

/**
 * ProtectedRoute Component
 * 
 * Admin rotalarını korur. Sadece oturum açmış ve admin yetkisine sahip kullanıcılar erişebilir.
 * 
 * Kontrol sırası:
 * 1. sessionStorage'da activeUser var mı?
 * 2. activeUser'ın subscription_status'u "admin" mi?
 * 
 * Eğer koşullar sağlanmazsa kullanıcıyı /chat'e yönlendirir.
 */
export default function ProtectedRoute({ children }) {
  const [isAuthorized, setIsAuthorized] = useState(null); // null = checking, true/false = result
  
  useEffect(() => {
    const checkAuth = () => {
      try {
        // Admin token ve bilgisini kontrol et
        const adminToken = sessionStorage.getItem('adminToken');
        const adminUserStr = sessionStorage.getItem('adminUser');
        
        if (!adminToken || !adminUserStr) {
          console.log("🚫 ProtectedRoute: No admin session found");
          setIsAuthorized(false);
          return;
        }
        
        const adminUser = JSON.parse(adminUserStr);
        
        // Admin bilgisi var mı kontrol et
        if (!adminUser.email || !adminUser.role) {
          console.log("🚫 ProtectedRoute: Invalid admin data");
          setIsAuthorized(false);
          return;
        }
        
        console.log("✅ ProtectedRoute: Admin access granted", adminUser.email);
        setIsAuthorized(true);
      } catch (error) {
        console.error("ProtectedRoute auth check error:", error);
        setIsAuthorized(false);
      }
    };
    
    checkAuth();
  }, []);
  
  // Loading state
  if (isAuthorized === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 to-gray-800">
        <div className="text-white text-xl">🔐 Yetki kontrol ediliyor...</div>
      </div>
    );
  }
  
  // Not authorized - redirect to admin login
  if (isAuthorized === false) {
    console.log("🔄 ProtectedRoute: Redirecting to /admin");
    return <Navigate to="/admin" replace />;
  }
  
  // Authorized - render children
  return children;
}
